import { makeStyles } from '@material-ui/core/styles';
import { colors } from '@loggi/mar';

export default makeStyles({
  root: {
    background: colors.gradients.sanches
  }
});
